module.exports = __webpack_public_path__ + "img/print_logo.b84f344d.png";